// Hook odpowiedzialny za wywołanie akcji POST

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

// parametry requestu do api
export type IRequest = object;

// typ zwracanych danych
interface IResponse {
  data: object;
}

const update = (command_url: string, data: IRequest): Promise<IResponse> =>
  axios.put(command_url, data);

export const useUpdate = (
  command_url: string,
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => update(command_url, data), options);
